// JavaScript source code
import './styles/HomePage.css';
import { useSearchParams } from "react-router-dom";
import { ContactUsForm } from './ContactUs';
//import background from '.GameBackgrounds/SampleImageResized.png'
import { useState, useRef } from 'react';
//import sampleImage from '/public/SampleImage.png';
import GameImageHeader from './GameImageHeader';
import NewsletterSignUp from './NewsletterSignUp';
import PopupMessageContainer from './PopupAlerts/PopupMessageContainer.js';
import { GetAuthStatus } from './Utilities';
import Cookies from 'js-cookie';
import webContentStrings from "./ContentStrings/LocalizedStrings.js";

function UXHomePage() {
    const [queryParams] = useSearchParams();
    const [seenPopup, setSeenPopup] = useState(Cookies.get("SeenPopup") === 'true');

    function onGetStartedClick() {
        window.location.assign("/login?page=signUp")
    }

    return (
        <div className="homePage">
            {seenPopup !== true && <PopupMessageContainer />}
            <div className="titleLine">
                <GameImageHeader />
                <div className="topBody">
                    <div className="info">
                        <h1 className="title">{webContentStrings.homePageStrings.pageTitle}</h1> <br />
                        <h2 className="tagline">{webContentStrings.homePageStrings.pageTagLine}</h2>
                        <p className="subTagLine">{webContentStrings.homePageStrings.pageSubTagLine}</p>
                        <button className="startButton" onClick={onGetStartedClick}>{webContentStrings.homePageStrings.startButtonText}</button>
                    </div>
                </div>
            </div>
            <div className="companyDesc">
                <img className="studioImage" src="/LudareLogoTransparent.png" alt="Ludare Logo" />
                <div className="descText">
                    <p className="descTitle">{webContentStrings.homePageStrings.descTitle}</p>
                    <p className="descDesc">{webContentStrings.homePageStrings.descText}</p>
                </div>
            </div>

            <div className="roleSelection">
                <h1 className="roleQuestion">{webContentStrings.homePageStrings.roleTitle}</h1>
                <div className="roleTiles">
                    <div className="playerTile">
                        <div className="playerTileTitle">
                            <img className="playerTileImage" src="/gamepad-recolored.png" alt="Gamepad Icon" />
                            <p className="playerTileTitleText">{webContentStrings.homePageStrings.playerRoleTitle}</p>
                        </div>
                        <p className="playerTileText">{webContentStrings.homePageStrings.playerRoleDesc}</p>
                        <a className="playerTileSelect" href="/players">{webContentStrings.homePageStrings.playerRoleSelect}</a>
                    </div>
                    <div className="developerTile">
                        <div className="developerTileTitle">
                            <img className="developerTileImage" src="/developer-recolored.png" alt="Game Developer Icon" />
                            <p className="developerTileTitleText">{webContentStrings.homePageStrings.devRoleTitle}</p>
                        </div>
                        <p className="developerTileText">{webContentStrings.homePageStrings.devRoleDesc}</p>
                        <a className="developerTileSelect" href="/studios">{webContentStrings.homePageStrings.devRoleSelect}</a>
                    </div>
                </div>
            </div>

            <div className="newsletterSignUp">
                <NewsletterSignUp />
            </div>
        </div>
    );
}

export default UXHomePage;